import { useCallback, useEffect, useState } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { qrScannerApi, type ScannedAttendeeItem } from "../qrScanner.api";

export const useScannerScannedAttendees = (eventId: string | undefined) => {
  const [attendees, setAttendees] = useState<ScannedAttendeeItem[]>([]);
  const [error, setError] = useState<string | null>(null);
  const { run, loading } = useLatestRequest();

  const refetch = useCallback(async () => {
    if (!eventId) {
      setError("Event ID not found");
      return;
    }
    setError(null);
    try {
      const result = await run((signal) => qrScannerApi.getScannedAttendees(eventId, signal));
      if (result !== undefined) setAttendees(result);
    } catch (requestError: unknown) {
      setError(getApiErrorMessage(requestError, "Failed to load attendees"));
    }
  }, [eventId, run]);

  useEffect(() => {
    void refetch();
  }, [refetch]);
  return { attendees, error, isLoading: loading, refetch };
};
